module.exports = __webpack_public_path__ + "static/img/bzzb.066305d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/bzzb.png
// module id = zYoO
// module chunks = 1